import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import NewsPage, {
  type ReleaseUpdate,
} from "../../../pages/HomePage/News/NewsPage";

type ReleaseJsonData = {
  id: string;
  highlightCount: number;
  features: { key: string; image?: string; hasCta?: boolean }[];
  bugfixCount?: number;
};

const allModules = import.meta.glob<{ default: ReleaseJsonData }>(
  "../../../pages/HomePage/News/assets/*.json",
  { eager: true }
);

function getSortKey(path: string): number {
  const filename = path.split("/").pop() ?? "";
  const yearMatch = filename.match(/(\d{4})/);
  const year = yearMatch ? parseInt(yearMatch[1]) : 0;
  const halfMatch = filename.match(/h(\d)/);
  if (halfMatch) return year * 10 + parseInt(halfMatch[1]);
  const quarterMatch = filename.match(/q(\d)/);
  if (quarterMatch) return year * 10 + parseInt(quarterMatch[1]);
  return year * 10;
}

const sortedReleases = Object.entries(allModules)
  .sort(([a], [b]) => getSortKey(b) - getSortKey(a))
  .map(([, m]) => m.default);

export const Route = createFileRoute("/(app)/home/news")({
  component: RouteComponent,
  validateSearch: (search: Record<string, any>): { version?: string } => ({
    version: search.version ?? "",
  }),
});

function RouteComponent() {
  const { version } = useSearch({ from: "/(app)/home/news" });
  const { t } = useTranslation();
  const allReleases: ReleaseUpdate[] = sortedReleases.map((r) => ({
    ...r,
    period: t(`home.news.release.${r.id}.period`),
  }));
  const selectedRelease =
    allReleases.find((r) => r.id === version) ?? allReleases[0];

  return <NewsPage update={selectedRelease} allReleases={allReleases} />;
}
